module.exports = __webpack_public_path__ + "static/media/Image-Milestones1.843e9f99.png";